const api = '/api/v1/u007_r_tran_recoms_controller.php';
import axios from 'axios';
export const tran_recoms_repository =  {
    get(data){
        return  axios.get(api,data);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

